import { FieldRenderProps } from 'react-final-form';
import { Input } from '@chakra-ui/react';
import React from 'react';

type Props = FieldRenderProps<string, any>;

const TextInputHidden: React.FC<Props> = ({
  input, label, numberFormat: boolean, ...rest
}: Props) => (
  <Input type="hidden" {...input} {...rest} />
);

export default TextInputHidden;
